import { useState, useEffect, memo } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import Fab from "@mui/material/Fab";
import Zoom from "@mui/material/Zoom";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";

import EditIconButtons from "../../components/EditIconButtons";
import EditNoteArea from "./EditNoteArea";
import {
  useUpdateNoteMutation,
  useDeleteNoteMutation,
  useGetNotesQuery,
} from "./notesApiSlice";

function Note(props) {
  const { name } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { note } = useGetNotesQuery("notesList", {
    selectFromResult: ({ data }) => ({
      note: data?.entities[props.id],
    }),
  });

  const [isExpanded, setExpand] = useState(false);
  const [updateBtn, setUpdateBtn] = useState(false);
  const [isNoteEdited, setNoteEdit] = useState(note);
  const [updateNote, { isSuccess: isUpdateSucess, reset: resetUpdate }] =
    useUpdateNoteMutation("notesList");
  const [deleteNote, { isSuccess: isDelSuccess, reset: resetDel }] =
    useDeleteNoteMutation();
  function expandInputArea() {
    setExpand(true);
    if (name !== undefined) {
      let { id } = location.state;
      navigate(`#notes/${isNoteEdited._id}`, { state: { id: id } });
    } else {
      navigate(`#notes/${isNoteEdited._id}`);
    }
  }
  function handleClose() {
    setExpand(false);
    if (name !== undefined) {
      let { id } = location.state;
      navigate(`/labels/${name}`, { state: { id: id } });
    } else {
      navigate("/");
    }
  }
  function onCancelLabelClicked(name) {
    let curLabels = isNoteEdited.labels;
    let newLabels = curLabels.filter((preItem) => {
      return preItem.name !== name;
    });
    setNoteEdit((preItems) => {
      return {
        ...preItems,
        labels: newLabels,
      };
    });
    if (!isExpanded) {
      setUpdateBtn(true);
    }
  }
  function editNoteBgColour(color) {
    setNoteEdit((prevState) => {
      return {
        ...prevState,
        bgColour: color,
      };
    });
    if (!isExpanded) {
      setUpdateBtn(true);
    }
  }
  function editNotePinStatus(pin) {
    setNoteEdit((prevState) => {
      return {
        ...prevState,
        pinned: pin,
      };
    });
    if (!isExpanded) {
      setUpdateBtn(true);
    }
  }
  function editNoteLabels(newLabels) {
    if (isNoteEdited.labels.some((e) => e._id === newLabels._id)) {
      const filteredLabels = isNoteEdited.labels.filter((preItem) => {
        return preItem._id !== newLabels._id;
      });
      setNoteEdit((prevState) => {
        return {
          ...prevState,
          labels: filteredLabels,
        };
      });
    } else {
      setNoteEdit((prevState) => {
        return {
          ...prevState,
          labels: [newLabels, ...prevState.labels],
        };
      });
    }
    if (!isExpanded) {
      setUpdateBtn(true);
    }
  }
  async function onUpdateNoteClicked(event) {
    await updateNote({ id: isNoteEdited._id, initialNote: isNoteEdited });
    event.preventDefault();
  }
  async function onDeleteNoteClicked(event) {
    await deleteNote({ id: isNoteEdited._id });
    event.preventDefault();
  }
  useEffect(() => {
    setNoteEdit(note);
  }, [note]);
  useEffect(() => {
    if (isUpdateSucess) {
      setExpand(false);
      setUpdateBtn(false);
      resetUpdate();
      /*if (isExpanded) {
        navigate("/");
      }*/
    }
    if (isDelSuccess) {
      setNoteEdit({});
      setExpand(false);
      setUpdateBtn(false);
      resetDel();
      /*if (isExpanded) {
        navigate("/");
      }*/
    }
  }, [isUpdateSucess, isDelSuccess, navigate, resetUpdate, resetDel]);
  if (isNoteEdited && !isUpdateSucess && !isDelSuccess) {
    return (
      <>
        <div className="note" style={{ background: isNoteEdited.bgColour }}>
          <div onClick={expandInputArea}>
            <h1>{isNoteEdited.title} </h1>
            <p>{isNoteEdited.content}</p>
          </div>

          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {isNoteEdited.labels?.length
              ? isNoteEdited.labels.map((e, i) => {
                  return (
                    <Chip
                      key={i}
                      i={i}
                      size="medium"
                      label={e.name}
                      onDelete={() => onCancelLabelClicked(e.name)}
                    />
                  );
                })
              : null}
          </Stack>
          {/*<time dateTime={date}>Latest edited At:{latestUpdatedAt}</time>*/}
          <EditIconButtons
            onBgColourClick={editNoteBgColour}
            onPinClick={editNotePinStatus}
            pinStatus={isNoteEdited.pinned}
            onDelClick={onDeleteNoteClicked}
            authorId={isNoteEdited.author_id}
            handleCheckedLabels={editNoteLabels}
            labelsList={isNoteEdited.labels}
          />
          <Zoom in={updateBtn}>
            <Fab
              className="btn-edit"
              type="button"
              onClick={(e) => {
                onUpdateNoteClicked(e);
              }}
            >
              <EditIcon />
            </Fab>
          </Zoom>
        </div>
        <EditNoteArea
          note={isNoteEdited}
          isExpanded={isExpanded}
          handleOnClose={handleClose}
          //latestUpdatedAt={latestUpdatedAt}
        />
      </>
    );
  }
}
//export default Note;
const memoizedNote = memo(Note);
export default memoizedNote;
